
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { SettlementModel } from './Entities.GormCrm.Settlement';
import { Model, ModelProperty } from 'models/Model';


export class SettlementPaymentModel extends Model<SettlementPaymentModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'string', isHidden: true },
		{ name: 'settlementId', type: 'string' },
		{ name: 'amount', type: 'number' },
		{ name: 'created', type: 'Date', isHidden: true },
		{ name: 'settlement', type: 'SettlementModel', isHidden: true, isObject: true, new: () => { return new SettlementModel }, properties: () => { return SettlementModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public settlementId?: string;
	public amount: number;
	public created?: Date;
	public settlement?: SettlementModel;
    
	constructor(){
		super();
		this.id = undefined;
		this.settlementId = undefined;
		this.amount = 0;
		this.created = undefined;
		this.settlement = undefined;
		
	}
	getProperties(){
		return SettlementPaymentModel.classProperties;
	}
}

